import React from 'react';

// 表格操作列：统一展示“查看、修改、删除”等文字按钮。
export default function ActionLinks({ links }) {
  return (
    <div className="flex space-x-3 justify-center">
      {links.map((link, i) => (
        <span key={i} onClick={link.onClick} className="text-[#1890ff] cursor-pointer hover:underline text-[13px] whitespace-nowrap">
          {link.text}
        </span>
      ))}
    </div>
  );
}
